import { Divider, Grid2, Tab, Tabs } from "@mui/material";
import DashboardLayout from "layouts/DashboardLayout";
import { useState } from "react";
import AdvisorTable from "./AdvisorTable";
import ClientsTable from "./ClientsTable";
import EmployeeTable from "./EmployeeTable";
import EquityBasketTable from "./EquityBasketTable";
import PartnerTable from "./PartnerTable";
import PortfolioList from "./PortfolioList";

const UserDetails = () => {
  // const navigate = useNavigate();
  // const profileTabs = [
  //   "Advisor",
  //   "Employee",
  //   "Clients",
  //   "Partner",
  //   "Equity Basket",
  // ];
  const [activeTab, setActiveTab] = useState(0);

  return (
    <DashboardLayout title="User Details">
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <Tabs
            variant="scrollable"
            value={activeTab}
            onChange={(e, val) => {
              setActiveTab(val);
            }}
          >
            <Tab disableRipple label="Advisor" />
            <Tab disableRipple label="Employee" />
            <Tab disableRipple label="Clients" />
            <Tab disableRipple label="Partner" />
            <Tab disableRipple label="Equity Basket" />
            <Tab disableRipple label="Portfolios" />
          </Tabs>
          <Divider />
        </Grid2>

        <Grid2 size={12}>
          {activeTab === 0 && <AdvisorTable />}
          {activeTab === 1 && <EmployeeTable />}
          {activeTab === 2 && <ClientsTable />}
          {activeTab === 3 && <PartnerTable />}
          {activeTab === 4 && <EquityBasketTable />}
          {activeTab === 5 && <PortfolioList />}
        </Grid2>
      </Grid2>
    </DashboardLayout>
  );
};

export default UserDetails;
